import   React              from 'react'
import { inject, observer } from 'mobx-react'

import { InputGroupAddon  } from 'reactstrap'

import { Button           } from 'sdc-react-basics'

export const FilterButton = inject('featuresStore','boardsStore')(observer(({featuresStore,boardsStore,icon,toggle='dummy',type='prepend',color='#666',style={},...props}) =>
  <InputGroupAddon addonType={type}>
    <Button icon={icon} style={style} className={'filter status-'+toggle} title={'feature.filter.'+toggle}
        onClick={featuresStore.toggle(toggle)}
        active={toggle !== 'dummy' && featuresStore.filters[toggle]}
        caption={boardsStore.selected[toggle] ? boardsStore.selected[toggle] : undefined}
        disabled={toggle !== 'dummy' && !boardsStore.selected[toggle]}
        {...props}
    />
  </InputGroupAddon>
))
